import { applyMiddleware, combineReducers } from "redux";
import { thunk } from "redux-thunk";
import { createStore } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

// Reducers
import rdvReducer from "reducers/rdvReducer";
import authReducer from "reducers/authReducer";
import mediatorReducer from 'reducers/mediatorReducer';
import collaboratorReducer from "reducers/collaboratorReducer";
import searchFilterReducer from "reducers/searchFilterReducer";
import calendarReducer from 'reducers/calendarReducer';


// Combine reducers if needed
const rootReducer = combineReducers({
  auth: authReducer,
  collaborator: collaboratorReducer,
  rdv: rdvReducer,
  searchFilter:searchFilterReducer,
  mediator: mediatorReducer,
  calendar: calendarReducer
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ['auth', 'calendar']

};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(persistedReducer, applyMiddleware(thunk));
export const persistor = persistStore(store);
